import { FAQItem } from '../types';

export const carcassonneFaq: FAQItem[] = [
  {
    "id": "faq-b04",
    "question": "Czy przy remisie dzielimy punkty?",
    "answer": "Nie. Każdy gracz z największą siłą na ukończonym obszarze otrzymuje pełną wartość punktową. Punktów nie dzieli się na pół. Remis końcowego wyniku na torze to osobna sprawa: wtedy gracze dzielą zwycięstwo.",
    "requiredModuleIds": [
          "base"
    ],
    "group": "Podstawa",
    "tags": [
          "podstawa"
    ]
  },
  {
    "id": "faq-b04b",
    "question": "Co jeśli po finale dwóch graczy ma ten sam najwyższy wynik?",
    "answer": "Dzielą zwycięstwo. Nie rozstrzyga się remisu liczbą ukończonych miast, herbów ani wolnych figurek — porównuje się wyłącznie końcowy wynik na torze punktacji.",
    "requiredModuleIds": [
          "base"
    ],
    "group": "Podstawa",
    "tags": [
          "podstawa",
          "remis"
    ]
  },
  {
    "id": "faq-b01",
    "question": "Czy muszę postawić meepla?",
    "answer": "Nie. Umieszczenie figury po dołożeniu kafelka jest zawsze opcjonalne. Możesz zachować meepla na późniejszą, pewniejszą okazję.",
    "requiredModuleIds": [
          "base"
    ],
    "group": "Podstawa",
    "tags": [
          "podstawa"
    ]
  },
  {
    "id": "faq-b02",
    "question": "Czy mogę postawić meepla na starszym kafelku?",
    "answer": "W grze podstawowej nie. Figura staje na obszarze należącym do kafelka właśnie dołożonego. Wyjątki pojawiają się dopiero w aktywnych dodatkach, na przykład przy magicznym portalu.",
    "requiredModuleIds": [
          "base"
    ],
    "group": "Podstawa",
    "tags": [
          "podstawa"
    ]
  },
  {
    "id": "faq-b03",
    "question": "Czy mogę wejść do zajętego miasta od innej strony?",
    "answer": "Nie bezpośrednio. Możesz wystawić rycerza tylko w wolnym mieście, a później połączyć je kafelkiem z innym miastem — wtedy decyduje większość.",
    "requiredModuleIds": [
          "base"
    ],
    "group": "Podstawa",
    "tags": [
          "podstawa"
    ]
  },
  {
    "id": "faq-b05",
    "question": "Czy klasztor potrzebuje kafelków po przekątnej?",
    "answer": "Tak — klasztor wymaga wszystkich ośmiu sąsiadów (w tym po przekątnej), zanim zostanie ukończony i punktowany.",
    "requiredModuleIds": [
          "base"
    ],
    "group": "Podstawa",
    "tags": [
          "podstawa"
    ]
  },
  {
    "id": "faq-b06",
    "question": "Czy pole może zostać ukończone w trakcie gry?",
    "answer": "Nie. Pola (łąki) nigdy nie kończą się w trakcie partii; chłopi punktują wyłącznie podczas punktowania końcowego.",
    "requiredModuleIds": [
          "base"
    ],
    "group": "Podstawa",
    "tags": [
          "podstawa"
    ]
  },
  {
    "id": "faq-b07",
    "question": "Czy jedno miasto może punktować dla dwóch pól?",
    "answer": "Tak. Jedno ukończone miasto może dawać punkty kilku sąsiadującym polom, jeśli każde z tych pól je otacza według zasad chłopów.",
    "requiredModuleIds": [
          "base"
    ],
    "group": "Podstawa",
    "tags": [
          "podstawa"
    ]
  },
  {
    "id": "faq-b08",
    "question": "Czy jeden kafelek drogi liczy się dwa razy?",
    "answer": "Nie dla tej samej drogi — jeden kafelek liczy się raz w punktowaniu danej drogi, nawet jeśli ma kilka odcinków tej drogi.",
    "requiredModuleIds": [
          "base"
    ],
    "group": "Podstawa",
    "tags": [
          "podstawa"
    ]
  },
  {
    "id": "faq-b09",
    "question": "Czy mogę położyć kafelek tylko narożnikiem?",
    "answer": "Nie. Kafelek musi stykać się pełną krawędzią z już leżącym kafelkiem; samo stykanie narożnikiem jest niedozwolone.",
    "requiredModuleIds": [
          "base"
    ],
    "group": "Podstawa",
    "tags": [
          "podstawa"
    ]
  },
  {
    "id": "faq-b10",
    "question": "Co jeśli nie da się dołożyć kafelka?",
    "answer": "Po pełnym sprawdzeniu odłóż i dobierz kolejny.",
    "requiredModuleIds": [
          "base"
    ],
    "group": "Podstawa",
    "tags": [
          "podstawa"
    ]
  },
  {
    "id": "faq-b11",
    "question": "Ile meepli mam w zasobie?",
    "answer": "Zwykle 7 do gry + 1 na torze (plus opat/duży meeple według dodatków).",
    "requiredModuleIds": [
          "base"
    ],
    "group": "Podstawa",
    "tags": [
          "podstawa"
    ]
  },
  {
    "id": "faq-b12",
    "question": "Czy chłop wraca po zamknięciu pola?",
    "answer": "Nie — figura zwykle zostaje do punktowania obszaru albo do końca gry; wyjątki wynikają wyłącznie z efektów rozszerzeń.",
    "requiredModuleIds": [
          "base"
    ],
    "group": "Podstawa",
    "tags": [
          "podstawa"
    ]
  },
  {
    "id": "faq-b13",
    "question": "Czy mogę mieć wielu meepli w jednym obszarze?",
    "answer": "Tak, jeśli połączyłeś wcześniej osobne legalne wejścia.",
    "requiredModuleIds": [
          "base"
    ],
    "group": "Podstawa",
    "tags": [
          "podstawa"
    ]
  },
  {
    "id": "faq-b14",
    "question": "Czy skrzyżowanie kończy drogę?",
    "answer": "Tak, widoczne zakończenie/skrzyżowanie zamyka koniec drogi.",
    "requiredModuleIds": [
          "base"
    ],
    "group": "Podstawa",
    "tags": [
          "podstawa"
    ]
  },
  {
    "id": "faq-b15",
    "question": "Kiedy kończy się gra?",
    "answer": "Po ostatnim kafelku i pełnej turze, potem punktowanie końcowe.",
    "requiredModuleIds": [
          "base"
    ],
    "group": "Podstawa",
    "tags": [
          "podstawa"
    ]
  },
  {
    "id": "faq-r01",
    "question": "Czy rzeka jest drogą?",
    "answer": "Nie. Rzeka zastępuje zwykły kafelek startowy sekwencją kafelków rzeki i ma własne ograniczenia układania.",
    "requiredModuleIds": [
          "river"
    ],
    "group": "Rzeka i Opat",
    "tags": [
          "rzeka i opat"
    ]
  },
  {
    "id": "faq-r02",
    "question": "Czy można postawić meepla na wodzie?",
    "answer": "Nie. Nie wolno kłaść dwóch zakrętów rzeki bezpośrednio po sobie — między zakrętami musi być prosty odcinek.",
    "requiredModuleIds": [
          "river"
    ],
    "group": "Rzeka i Opat",
    "tags": [
          "rzeka i opat"
    ]
  },
  {
    "id": "faq-r03",
    "question": "Czy wolno dwa razy skręcić Rzeką w tę samą stronę?",
    "answer": "Nie, jeśli tworzy zakazane ciasne zawinięcie.",
    "requiredModuleIds": [
          "river"
    ],
    "group": "Rzeka i Opat",
    "tags": [
          "rzeka i opat"
    ]
  },
  {
    "id": "faq-a01",
    "question": "Czy opat może być chłopem?",
    "answer": "Nie. Opat jest osobną figurą na klasztory i ogrody; nie zastępuje zwykłego meepla we wszystkich rolach.",
    "requiredModuleIds": [
          "abbot"
    ],
    "group": "Rzeka i Opat",
    "tags": [
          "rzeka i opat"
    ]
  },
  {
    "id": "faq-a02",
    "question": "Czy mogę wycofać opata i postawić meepla w tej samej turze?",
    "answer": "Nie. Opat może stać na klasztorze lub ogrodzie; nie umieszczasz go jako zwykłego podróżnika, rycerza ani chłopa.",
    "requiredModuleIds": [
          "abbot"
    ],
    "group": "Rzeka i Opat",
    "tags": [
          "rzeka i opat"
    ]
  },
  {
    "id": "faq-a03",
    "question": "Czy ogród punktuje jak klasztor?",
    "answer": "Tak — punktujesz 1 punkt za klasztor/ogród oraz po 1 za każdego sąsiada, także gdy wycofujesz opata wcześniej.",
    "requiredModuleIds": [
          "abbot"
    ],
    "group": "Rzeka i Opat",
    "tags": [
          "rzeka i opat"
    ]
  },
  {
    "id": "faq-m01a",
    "question": "Czy dwie karczmy potrajają drogę?",
    "answer": "Nie. Karczma podwaja punkty ukończonej drogi, ale nieukończona droga z karczmą na końcu gry jest warta 0 punktów.",
    "requiredModuleIds": [
          "major-01-inns-cathedrals"
    ],
    "group": "Karczmy",
    "tags": [
          "karczmy"
    ]
  },
  {
    "id": "faq-m01b",
    "question": "Czy nieukończona droga z karczmą daje zero?",
    "answer": "Nie w C3.1 — nieukończone miasto z katedrą daje 1 punkt za kafelek i 1 za herb (bez podwojenia).",
    "requiredModuleIds": [
          "major-01-inns-cathedrals"
    ],
    "group": "Karczmy",
    "tags": [
          "karczmy"
    ]
  },
  {
    "id": "faq-m01c",
    "question": "Czy duży meeple dostaje podwójne punkty?",
    "answer": "Nie, duży meeple ma tylko siłę 2 przy większości; nie zajmuje dwóch obszarów naraz ani nie daje podwójnych punktów.",
    "requiredModuleIds": [
          "major-01-inns-cathedrals"
    ],
    "group": "Karczmy",
    "tags": [
          "karczmy"
    ]
  },
  {
    "id": "faq-m01d",
    "question": "Czy nieukończona katedra daje zero?",
    "answer": "Nie w C3.1 — szósty gracz punktuje normalnie według zasad większości (siła 1+1 przy dużym meeplu).",
    "requiredModuleIds": [
          "major-01-inns-cathedrals"
    ],
    "group": "Karczmy",
    "tags": [
          "karczmy"
    ]
  },
  {
    "id": "faq-m02a",
    "question": "Kto bierze towary?",
    "answer": "Towary zbiera gracz, który kończy miasto (kładzie zamykający kafelek), niezależnie od tego, kto ma w nim rycerzy.",
    "requiredModuleIds": [
          "major-02-traders-builders"
    ],
    "group": "Kupcy",
    "tags": [
          "kupcy"
    ]
  },
  {
    "id": "faq-m02b",
    "question": "Czy budowniczy liczy się do większości?",
    "answer": "Nie. Budowniczy daje dodatkową turę tylko wtedy, gdy faktycznie dołożysz kafelek do obszaru z Twoim budowniczym.",
    "requiredModuleIds": [
          "major-02-traders-builders"
    ],
    "group": "Kupcy",
    "tags": [
          "kupcy"
    ]
  },
  {
    "id": "faq-m02c",
    "question": "Czy budowniczy zostaje po dodatkowej turze?",
    "answer": "Nie — świnia wraca do zapasu przed punktowaniem końcowym pola, jeśli nie spełnia warunków premii C3.1.",
    "requiredModuleIds": [
          "major-02-traders-builders"
    ],
    "group": "Kupcy",
    "tags": [
          "kupcy"
    ]
  },
  {
    "id": "faq-m02d",
    "question": "Co uruchamia świnie?",
    "answer": "Ukończenie miasta z co najmniej jednym herbem.",
    "requiredModuleIds": [
          "major-02-traders-builders"
    ],
    "group": "Kupcy",
    "tags": [
          "kupcy"
    ]
  },
  {
    "id": "faq-m02e",
    "question": "Czy świnia potrzebuje większości pola?",
    "answer": "Nie przy swoim punktowaniu w C3.1 — sprawdź dokładną sekwencję powrotu budowniczego w rozdziale Kupców.",
    "requiredModuleIds": [
          "major-02-traders-builders"
    ],
    "group": "Kupcy",
    "tags": [
          "kupcy"
    ]
  },
  {
    "id": "faq-m02f",
    "question": "Czy świnia daje punkty na końcu?",
    "answer": "Nie. Towary punktuje się na końcu gry według większości zestawów; w trakcie gry tylko je zbierasz.",
    "requiredModuleIds": [
          "major-02-traders-builders"
    ],
    "group": "Kupcy",
    "tags": [
          "kupcy"
    ]
  },
  {
    "id": "faq-m03a",
    "question": "Ile ruchów wykonuje smok?",
    "answer": "Dokładnie dwa, każdy prosto do końca pasa.",
    "requiredModuleIds": [
          "major-03-dragon-fairy"
    ],
    "group": "Smok",
    "tags": [
          "smok"
    ]
  },
  {
    "id": "faq-m03b",
    "question": "Czy smok skręca w połowie ruchu?",
    "answer": "Nie. Smok wykonuje dwa proste ruchy (bez przekątnych) według aktualnych zasad C3.1 Wróżki i Smoka.",
    "requiredModuleIds": [
          "major-03-dragon-fairy"
    ],
    "group": "Smok",
    "tags": [
          "smok"
    ]
  },
  {
    "id": "faq-m03c",
    "question": "Kiedy dostaję wróżkę?",
    "answer": "Po ukończeniu drogi/miasta bez własnych punktów.",
    "requiredModuleIds": [
          "major-03-dragon-fairy"
    ],
    "group": "Smok",
    "tags": [
          "smok"
    ]
  },
  {
    "id": "faq-m03d",
    "question": "Czy wróżka chroni wszystkich na kafelku?",
    "answer": "Chroni przypisanego meepla i siebie; inne są usuwane.",
    "requiredModuleIds": [
          "major-03-dragon-fairy"
    ],
    "group": "Smok",
    "tags": [
          "smok"
    ]
  },
  {
    "id": "faq-m03e",
    "question": "Czy portal pozwala wejść do zajętego miasta?",
    "answer": "Nie. Magiczny portal pozwala postawić figurę na starszym kafelku, ale nadal obowiązują reguły zajętości obszaru.",
    "requiredModuleIds": [
          "major-03-dragon-fairy"
    ],
    "group": "Smok",
    "tags": [
          "smok"
    ]
  },
  {
    "id": "faq-m04a",
    "question": "Czy wieża porywa meeple?",
    "answer": "Nie w C3.1 — Wieże i Złodzieje nie porywają meepli jak dawne wieże; obowiązują strażnicy i symbole złodzieja.",
    "requiredModuleIds": [
          "major-04-towers-thieves"
    ],
    "group": "Wieże",
    "tags": [
          "wieże"
    ]
  },
  {
    "id": "faq-m04b",
    "question": "Czy luka przerywa zasięg wieży?",
    "answer": "Nie, pusty poziom wieży nie „łapie” figury, ale liczy się do odległości zasięgu wieży przy dalszej budowie.",
    "requiredModuleIds": [
          "major-04-towers-thieves"
    ],
    "group": "Wieże",
    "tags": [
          "wieże"
    ]
  },
  {
    "id": "faq-m04c",
    "question": "Czy na wieży może stać kilku strażników?",
    "answer": "Nie. Symbol złodzieja w C3.1 działa według zasad tego rozszerzenia i nie kopiuje mechaniki Bandytów z minidodatku.",
    "requiredModuleIds": [
          "major-04-towers-thieves"
    ],
    "group": "Wieże",
    "tags": [
          "wieże"
    ]
  },
  {
    "id": "faq-m04d",
    "question": "Co jeśli złodziej bez strażników?",
    "answer": "Kradzież kafelka i wejście kafelka wieży.",
    "requiredModuleIds": [
          "major-04-towers-thieves"
    ],
    "group": "Wieże",
    "tags": [
          "wieże"
    ]
  },
  {
    "id": "faq-m05a",
    "question": "Czy ratusz zawsze pasuje?",
    "answer": "Tak. Ratusze, burmistrzowie, kurierzy i strachy na wróble to elementy dużego rozszerzenia C3.1 — nie myl z minikurierami.",
    "requiredModuleIds": [
          "major-05-messengers-mayors"
    ],
    "group": "Burmistrzowie",
    "tags": [
          "burmistrzowie"
    ]
  },
  {
    "id": "faq-m05b",
    "question": "Jaka jest siła burmistrza?",
    "answer": "Strach na wróble ma siłę 0 i nie tworzy większości; wpływa na inne efekty opisane w rozdziale Kurierów i Burmistrzów.",
    "requiredModuleIds": [
          "major-05-messengers-mayors"
    ],
    "group": "Burmistrzowie",
    "tags": [
          "burmistrzowie"
    ]
  },
  {
    "id": "faq-m05c",
    "question": "Czy to to samo co minidodatek Kurierzy?",
    "answer": "Nie — minidodatek Wiadomości ma zupełnie inne zasady niż duże rozszerzenie Kurierzy i Burmistrzowie C3.1.",
    "requiredModuleIds": [
          "major-05-messengers-mayors"
    ],
    "group": "Burmistrzowie",
    "tags": [
          "burmistrzowie"
    ]
  },
  {
    "id": "faq-m05d",
    "question": "Kiedy kończy się gra z ratuszami?",
    "answer": "Turniej/efekt ratuszy rozstrzyga się, gdy wszystkie ratusze leżą już na planszy — szczegóły w rozdziale major-05.",
    "requiredModuleIds": [
          "major-05-messengers-mayors"
    ],
    "group": "Burmistrzowie",
    "tags": [
          "burmistrzowie"
    ]
  },
  {
    "id": "faq-m06a",
    "question": "Czy godło jest meeplem?",
    "answer": "Nie. Turnieje i Godła C3.1 to inne mechaniki niż dawny Hrabia, Król i Rzeka; nie mieszaj starych zasad.",
    "requiredModuleIds": [
          "major-06-jousts-crests"
    ],
    "group": "Turnieje",
    "tags": [
          "turnieje"
    ]
  },
  {
    "id": "faq-m06b",
    "question": "Ile nominacji na turę?",
    "answer": "W mieście może być maksymalnie jedna aktywna nagroda/godło według limitu opisanego w Turniejach i Godłach.",
    "requiredModuleIds": [
          "major-06-jousts-crests"
    ],
    "group": "Turnieje",
    "tags": [
          "turnieje"
    ]
  },
  {
    "id": "faq-m06c",
    "question": "Ile punktuje godło na posągu?",
    "answer": "Punktacja herbu w tym module wynosi 3 × liczba herbów w danym mieście według tabeli Turniejów i Godła.",
    "requiredModuleIds": [
          "major-06-jousts-crests"
    ],
    "group": "Turnieje",
    "tags": [
          "turnieje"
    ]
  },
  {
    "id": "faq-m07a",
    "question": "Ile punktów za kontratak?",
    "answer": "3 za każdego własnego meepla na stanowisku.",
    "requiredModuleIds": [
          "major-07-siege-defense"
    ],
    "group": "Oblężenie",
    "tags": [
          "oblężenie"
    ]
  },
  {
    "id": "faq-m07b",
    "question": "Czy to stara Katapulta?",
    "answer": "Nie — Oblężenie i Obrona C3.1 to inne zasady niż stara Katapulta; nie przenoś procedur C1/C2.",
    "requiredModuleIds": [
          "major-07-siege-defense"
    ],
    "group": "Oblężenie",
    "tags": [
          "oblężenie"
    ]
  },
  {
    "id": "faq-m07c",
    "question": "Czy twierdza liczy się jako miasto dla chłopów?",
    "answer": "Tak — twierdza może być punktowana jako ukończone miasto, gdy spełni warunki zamknięcia z rozdziału Oblężenia.",
    "requiredModuleIds": [
          "major-07-siege-defense"
    ],
    "group": "Oblężenie",
    "tags": [
          "oblężenie"
    ]
  },
  {
    "id": "faq-m08a",
    "question": "Ile budynków na turę?",
    "answer": "Maksymalnie jeden: most lub zamek lub stodoła.",
    "requiredModuleIds": [
          "major-08-castles-bridges"
    ],
    "group": "Zamki",
    "tags": [
          "zamki"
    ]
  },
  {
    "id": "faq-m08b",
    "question": "Ile punktuje most w trakcie gry?",
    "answer": "3 za kafelek mostu na ukończonej drodze.",
    "requiredModuleIds": [
          "major-08-castles-bridges"
    ],
    "group": "Zamki",
    "tags": [
          "zamki"
    ]
  },
  {
    "id": "faq-m08c",
    "question": "Czy są bazary?",
    "answer": "Nie w C3.1 Zamki i Mosty — bazary z dawnego dodatku nie wracają; obowiązują mosty, zamki i stodoły.",
    "requiredModuleIds": [
          "major-08-castles-bridges"
    ],
    "group": "Zamki",
    "tags": [
          "zamki"
    ]
  },
  {
    "id": "faq-m09a",
    "question": "Czy pasterz jest chłopem?",
    "answer": "Nie. W C3.1 Pasterze i Owce nie ma wzgórz z dawnego dodatku; obowiązują stada, wilki, gęsi i winnice.",
    "requiredModuleIds": [
          "major-09-sheep-shepherds"
    ],
    "group": "Pasterze",
    "tags": [
          "pasterze"
    ]
  },
  {
    "id": "faq-m09b",
    "question": "Czy wilk dotyczy wszystkich połączonych pasterzy?",
    "answer": "Tak. Wilk atakuje stado według procedur Pasterzy — usuwa owce zgodnie z rozdziałem o wypasie i zagrożeniach.",
    "requiredModuleIds": [
          "major-09-sheep-shepherds"
    ],
    "group": "Pasterze",
    "tags": [
          "pasterze"
    ]
  },
  {
    "id": "faq-m09c",
    "question": "Czy kilku pasterzy dzieli punkty?",
    "answer": "Nie — przy remisie kontroli każdy uprawniony gracz dostaje pełne punkty ze stada, bez dzielenia wyniku.",
    "requiredModuleIds": [
          "major-09-sheep-shepherds"
    ],
    "group": "Pasterze",
    "tags": [
          "pasterze"
    ]
  },
  {
    "id": "faq-m09d",
    "question": "Czy owce punktują na końcu?",
    "answer": "Nie, niewypasione stado nie daje punktów na końcu, jeśli reguły Pasterzy wymagają wcześniejszego wypasu.",
    "requiredModuleIds": [
          "major-09-sheep-shepherds"
    ],
    "group": "Pasterze",
    "tags": [
          "pasterze"
    ]
  },
  {
    "id": "faq-m09e",
    "question": "Czy są wzgórza?",
    "answer": "Nie w C3.1 Pasterze i Owce — winnice działają według tego wydania, bez mechanik usuniętych ze starszych dodatków.",
    "requiredModuleIds": [
          "major-09-sheep-shepherds"
    ],
    "group": "Pasterze",
    "tags": [
          "pasterze"
    ]
  },
  {
    "id": "faq-m10a",
    "question": "Czy po występie zabieramy meeple?",
    "answer": "Nie. Place cyrkowe i występy działają według Cyrku i Artystów C3.1; nie kopiuj zasad innych minidodatków.",
    "requiredModuleIds": [
          "major-10-circus-artists"
    ],
    "group": "Cyrk",
    "tags": [
          "cyrk"
    ]
  },
  {
    "id": "faq-m10b",
    "question": "Czy piramida punktuje od razu po trzecim akrobacie?",
    "answer": "Nie. Akrobaci i dyrektorka mają własne limity umieszczania opisane w rozdziale Cyrku — nie stawiaj ich jak zwykłych meepli wszędzie.",
    "requiredModuleIds": [
          "major-10-circus-artists"
    ],
    "group": "Cyrk",
    "tags": [
          "cyrk"
    ]
  },
  {
    "id": "faq-m10c",
    "question": "Czy dyrektorka ma siłę >1?",
    "answer": "Nie, dyrektorka ma siłę 1 przy większości i nie zastępuje dużego meepla ani innych figur specjalnych.",
    "requiredModuleIds": [
          "major-10-circus-artists"
    ],
    "group": "Cyrk",
    "tags": [
          "cyrk"
    ]
  },
  {
    "id": "faq-mi1",
    "question": "Czy lot maszyny wymaga kości?",
    "answer": "Tak — po wyborze lotu rzucasz kością lotu (1–3) i przesuwasz meepla o tyle kafelków w kierunku strzałki maszyny.",
    "requiredModuleIds": [
          "mini-01-flying-machines"
    ],
    "group": "Minis",
    "tags": [
          "minis"
    ]
  },
  {
    "id": "faq-mi2",
    "question": "Czy minikurierzy = major 5?",
    "answer": "Nie. Minidodatek Wiadomości (kurierzy Big Box) to osobne zasady; nie myl go z Kurierami i Burmistrzami C3.1 (major-05).",
    "requiredModuleIds": [
          "mini-02-messengers"
    ],
    "group": "Minis",
    "tags": [
          "minis"
    ]
  },
  {
    "id": "faq-mi3",
    "question": "Czy prom łączy dowolne przystanie?",
    "answer": "Prom zawsze łączy dokładnie dwie wybrane przystanie na jeziorze; pozostałe odcinki dróg na tym kafelku kończą się.",
    "requiredModuleIds": [
          "mini-03-ferries"
    ],
    "group": "Minis",
    "tags": [
          "minis"
    ]
  },
  {
    "id": "faq-mi4",
    "question": "Kiedy bierze się złoto?",
    "answer": "Złoto rozdaje się przy ukończeniu dowolnego obszaru na kafelku ze sztabkami — bierzesz sztabki z kafelków tego obszaru (klasztor: +8 sąsiadów).",
    "requiredModuleIds": [
          "mini-04-goldmines"
    ],
    "group": "Minis",
    "tags": [
          "minis"
    ]
  },
  {
    "id": "faq-mi5",
    "question": "Czy Mag i Wiedźma mogą być na jednej drodze?",
    "answer": "Nie. Mag i Wiedźma nigdy nie zajmują tego samego nieukończonego miasta ani drogi; przy kolizji natychmiast przenieś jedną figurę.",
    "requiredModuleIds": [
          "mini-05-mage-witch"
    ],
    "group": "Minis",
    "tags": [
          "minis"
    ]
  },
  {
    "id": "faq-mi6",
    "question": "Kiedy bandyta punktuje?",
    "answer": "Bandyta punktuje natychmiast, gdy śledzony znacznik zdobywa punkty: bierzesz połowę zaokrągloną w górę, potem bandyta wraca do zapasu.",
    "requiredModuleIds": [
          "mini-06-robbers"
    ],
    "group": "Minis",
    "tags": [
          "minis"
    ]
  },
  {
    "id": "faq-mi7",
    "question": "Czy kręgi dotyczą wszystkich graczy?",
    "answer": "Tak — po wyborze A lub B przez aktywnego wszyscy w kolejności (od lewego sąsiada) wykonują tę akcję, na końcu także aktywny.",
    "requiredModuleIds": [
          "mini-07-crop-circles"
    ],
    "group": "Minis",
    "tags": [
          "minis"
    ]
  },
  {
    "id": "faq-x02",
    "question": "Jaka jest zalecana pierwsza gra?",
    "answer": "Na pierwszą partię zaleca się samą podstawę z Rzeką i Opatem; duże rozszerzenia i minidodatki dodawaj dopiero po oswojeniu bazowych procedur.",
    "requiredModuleIds": [
          "base"
    ],
    "group": "Konfiguracja",
    "tags": [
          "konfiguracja"
    ]
  },
  {
    "id": "faq-x05",
    "question": "Czy C3.1 zmienia podstawę?",
    "answer": "Nie — C3.1 nie przepisuje całej podstawy; zmienia zasady konkretnych dużych rozszerzeń oznaczonych profilem C3.1.",
    "requiredModuleIds": [
          "base"
    ],
    "group": "Edycja",
    "tags": [
          "edycja"
    ]
  },
  {
    "id": "faq-mi1b",
    "question": "Czy lot może wylądować na zajętym obszarze?",
    "answer": "Tak — maszyna latająca pozwala wylądować na nieukończonym zajętym obszarze (wyjątek). Nie wolno lądować na polu ani na ukończonym obszarze; brak kafelka = nieudany lot i powrót meepla.",
    "requiredModuleIds": [
          "mini-01-flying-machines"
    ],
    "group": "Minis",
    "tags": [
          "minis",
          "lot"
    ]
  },
  {
    "id": "faq-mi2b",
    "question": "Czy przy współdzielonym ciemnym polu dobieram wiadomość?",
    "answer": "Nie. Wiadomość dobierasz tylko wtedy, gdy Twój znacznik punktów lub kurier jest sam na ciemnym polu. Obecność figury innego gracza blokuje dobranie.",
    "requiredModuleIds": [
          "mini-02-messengers"
    ],
    "group": "Minis",
    "tags": [
          "minis",
          "wiadomosci"
    ]
  },
  {
    "id": "faq-mi2c",
    "question": "Czy na końcu gry dobiera się wiadomości?",
    "answer": "Nie. Przed finałem sumujesz wynik znacznika i kuriera, zbierasz kuriera i dopiero potem punktujesz końcowo — bez dobierania wiadomości.",
    "requiredModuleIds": [
          "mini-02-messengers"
    ],
    "group": "Minis",
    "tags": [
          "minis",
          "wiadomosci"
    ]
  },
  {
    "id": "faq-mi3b",
    "question": "Czy przestawienie promu daje podwójną turę budowniczego?",
    "answer": "Nie. Samo przestawienie promu, nawet jeśli przedłuża drogę z Twoim budowniczym, nie daje dodatkowej tury — musisz dołożyć nowy kafelek na tę drogę.",
    "requiredModuleIds": [
          "mini-03-ferries"
    ],
    "group": "Minis",
    "tags": [
          "minis",
          "promy"
    ]
  },
  {
    "id": "faq-mi3c",
    "question": "W jakiej kolejności wystawiać i przestawiać promy?",
    "answer": "Najpierw dołóż kafelek i opcjonalnie meepla, potem wystaw nowy prom (jeśli kafelek jeziora), następnie ewentualnie przestaw istniejący prom, a na końcu punktuj. Każdy prom raz na turę.",
    "requiredModuleIds": [
          "mini-03-ferries"
    ],
    "group": "Minis",
    "tags": [
          "minis",
          "promy"
    ]
  },
  {
    "id": "faq-mi4b",
    "question": "Jak dzielić złoto przy remisie większości?",
    "answer": "Remisujący biorą po jednej sztabce, zaczynając od aktywnego gracza i idąc zgodnie z ruchem wskazówek zegara, aż na kafelkach scorowanego obszaru nie zostanie złoto.",
    "requiredModuleIds": [
          "mini-04-goldmines"
    ],
    "group": "Minis",
    "tags": [
          "minis",
          "zloto"
    ]
  },
  {
    "id": "faq-mi4c",
    "question": "Ile punktów daje 7 sztabek złota?",
    "answer": "Według tabeli Big Box: 7–9 sztabek = 3 punkty za sztabkę, więc 7 × 3 = 21 punktów. Próg 4–6 daje 2/szt., 10+ daje 4/szt., 1–3 daje 1/szt.",
    "requiredModuleIds": [
          "mini-04-goldmines"
    ],
    "group": "Minis",
    "tags": [
          "minis",
          "zloto"
    ]
  },
  {
    "id": "faq-mi4d",
    "question": "Czy chłopi dostają złoto z pól?",
    "answer": "Nie. Chłopi nigdy nie dostają złota: pola nie kończą się w trakcie gry, a nieodebrane sztabki zdejmuje się z planszy przed punktowaniem końcowym.",
    "requiredModuleIds": [
          "mini-04-goldmines"
    ],
    "group": "Minis",
    "tags": [
          "minis",
          "zloto"
    ]
  },
  {
    "id": "faq-mi5b",
    "question": "Jak Wiedźma zaokrągla połowę punktów?",
    "answer": "Wiedźma dzieli wynik obszaru na pół i zaokrągla w górę (np. 5 → 3). Przy karczmie/katedrze najpierw dolicz premię, potem dopiero połowę.",
    "requiredModuleIds": [
          "mini-05-mage-witch"
    ],
    "group": "Minis",
    "tags": [
          "minis",
          "mag"
    ]
  },
  {
    "id": "faq-mi5c",
    "question": "Czy Mag dodaje punkty za herby?",
    "answer": "Nie. Mag daje wyłącznie +1 punkt za każdy kafelek scorowanego obszaru; herby punktują według zwykłych zasad miasta bez dodatkowej premii Maga.",
    "requiredModuleIds": [
          "mini-05-mage-witch"
    ],
    "group": "Minis",
    "tags": [
          "minis",
          "mag"
    ]
  },
  {
    "id": "faq-mi6b",
    "question": "Czy połowę z bandyty zaokrągla się w górę?",
    "answer": "Tak. Bandyta bierze połowę punktów zdobytych przez śledzony znacznik, zaokrągloną w górę (np. z 5 punktów kradnie 3), a okradziony zachowuje pełną wartość.",
    "requiredModuleIds": [
          "mini-06-robbers"
    ],
    "group": "Minis",
    "tags": [
          "minis",
          "bandyci"
    ]
  },
  {
    "id": "faq-mi6c",
    "question": "Czy mogę poczekać z kradzieżą na większą zdobycz?",
    "answer": "Nie. Jeśli bandyta ma okazję okraść przesuwający się znacznik, musi to zrobić natychmiast; nie wolno odkładać kradzieży na później.",
    "requiredModuleIds": [
          "mini-06-robbers"
    ],
    "group": "Minis",
    "tags": [
          "minis",
          "bandyci"
    ]
  },
  {
    "id": "faq-mi6d",
    "question": "Co z bandytą pozostałym na torze przed finałem?",
    "answer": "Po końcu gry, a przed punktowaniem końcowym, bandyta nadal na torze daje 3 punkty swojemu właścicielowi, po czym wraca do zapasu.",
    "requiredModuleIds": [
          "mini-06-robbers"
    ],
    "group": "Minis",
    "tags": [
          "minis",
          "bandyci"
    ]
  },
  {
    "id": "faq-mi6e",
    "question": "Co robi bandyta przy punktach z cudzej kradzieży?",
    "answer": "Honor wśród złodziei: punkty zdobyte kradzieżą nie dają kolejnej kradzieży — bandyta przesuwa się wraz ze znacznikiem okradającego zamiast brać punkty.",
    "requiredModuleIds": [
          "mini-06-robbers"
    ],
    "group": "Minis",
    "tags": [
          "minis",
          "bandyci"
    ]
  },
  {
    "id": "faq-mi7b",
    "question": "Czy mogę dołożyć rycerza do miasta bez własnego rycerza?",
    "answer": "Nie przy akcji A. Dokładasz figurę wskazanego typu tylko do obszaru, na którym masz już co najmniej jedną figurę tego typu; inaczej pomijasz lub (jako aktywny) i tak wybierasz A/B.",
    "requiredModuleIds": [
          "mini-07-crop-circles"
    ],
    "group": "Minis",
    "tags": [
          "minis",
          "kregi"
    ]
  },
  {
    "id": "faq-mi7c",
    "question": "Kiedy wykonuje się akcję kręgu względem punktowania?",
    "answer": "Najpierw dołóż kafelek, opcjonalnie meepla i punktuj ukończone obszary; dopiero potem aktywny wybiera A lub B i wszyscy wykonują akcję kręgu w kolejności.",
    "requiredModuleIds": [
          "mini-07-crop-circles"
    ],
    "group": "Minis",
    "tags": [
          "minis",
          "kregi"
    ]
  },
  {
    "id": "faq-b16",
    "question": "Czy mogę przesunąć już legalnie położony kafelek?",
    "answer": "Nie. Po legalnym dołożeniu kafelka nie wolno go przesuwać ani obracać ponownie; wyjątki istnieją tylko jeśli konkretne rozszerzenie wprost na to pozwala.",
    "requiredModuleIds": [
          "base"
    ],
    "group": "Podstawa",
    "tags": [
          "podstawa"
    ]
  },
  {
    "id": "faq-gold-adj",
    "question": "Czy druga sztabka złota może trafić po przekątnej?",
    "answer": "Tak. Po dołożeniu kafelka ze złotem kładziesz 1 sztabkę na nim i 1 na wybranym sąsiednim kafelku, w tym po przekątnej; limitu sztabek na kafelku nie ma.",
    "requiredModuleIds": [
          "mini-04-goldmines"
    ],
    "group": "Minis",
    "tags": [
          "minis",
          "zloto"
    ]
  },
  {
    id: 'faq-mists-01',
    question: 'Czy mgła musi pasować do sąsiedniej mgły przy dołożeniu kafelka?',
    answer:
      'Nie. W trybie kooperacyjnym przy dopasowaniu krawędzi ignorujecie mgłę — liczą się tylko typowe krawędzie (droga, miasto, pole). Mgła wpływa na duchy i zamknięcie obszarów mgły, nie na legalność dołożenia.',
    requiredModuleIds: ['mists-over-carcassonne'],
    requiredMistsPlayMode: 'coop',
    group: 'Mgła',
    tags: ['mgla', 'kafelki'],
    sectionId: 'mists-fog-ghosts',
  },
  {
    id: 'faq-mists-02',
    question: 'Czy mogę jednocześnie wziąć punkty i usunąć duchy przy punktowaniu?',
    answer:
      'Nie. Przy każdym punktowaniu drużyna wybiera dokładnie jedną opcję: dodać punkty do wspólnego toru albo usunąć do 3 duchów z jednego kafelka. Nie wolno łączyć obu efektów w tym samym rozliczeniu.',
    requiredModuleIds: ['mists-over-carcassonne'],
    requiredMistsPlayMode: 'coop',
    group: 'Mgła',
    tags: ['punktowanie', 'duchy'],
    sectionId: 'mists-scoring-choice',
  },
  {
    id: 'faq-mists-03',
    question: 'Czy w Mgły wolno stawiać farmerów na polach?',
    answer:
      'Nie w trybie kooperacyjnym. Meeple wolno stawiać tylko na drogach, w miastach i (od poziomu 2) na zamkach. Pola nie punktują i nie ma scoringu końcowego farmerów.',
    requiredModuleIds: ['mists-over-carcassonne'],
    requiredMistsPlayMode: 'coop',
    group: 'Mgła',
    tags: ['meeple', 'pola'],
    sectionId: 'mists-roads-cities',
  },
  {
    id: 'faq-mists-04',
    question: 'Kiedy przegrywamy partię kooperacyjną?',
    answer:
      'Natychmiast, gdy musicie wystawić ducha, a w zapasie ich nie ma, albo gdy nie możecie dobrać kafelka, a wspólny znacznik jeszcze nie osiągnął żetonu celu. Osiągnięcie celu w trakcie tur kończy grę zwycięstwem.',
    requiredModuleIds: ['mists-over-carcassonne'],
    requiredMistsPlayMode: 'coop',
    group: 'Mgła',
    tags: ['przegrana', 'cel'],
    sectionId: 'mists-end-l1',
  },
  {
    id: 'faq-mists-05',
    question: 'Czym różni się dodatek klasyczny od kooperacji?',
    answer:
      'W trybie „dodatek klasyczny” mieszacie elementy Mgły z konkurencyjnym Carcassonne (farmerzy i scoring C3 obowiązują). Procedury poziomów 1–6, wspólny tor i wybór punkty-lub-duchy należą wyłącznie do trybu kooperacyjnego — nie łączcie obu w jednej partii.',
    requiredModuleIds: ['mists-over-carcassonne'],
    group: 'Mgła',
    tags: ['tryb', 'klasyka'],
    sectionId: 'mists-classic-overview',
  },
  {
    id: 'faq-mists-06',
    question: 'Ile boków zamyka zwykły cmentarz na poziomie 2?',
    answer:
      'Zwykły cmentarz zamyka się, gdy wszystkie cztery boki (ortogonalne) są zajęte przez kafelki. Nawiedzony cmentarz (poziomy 5–6) wymaga ośmiu otaczających kafelków, w tym narożników.',
    requiredModuleIds: ['mists-over-carcassonne'],
    requiredMistsPlayMode: 'coop',
    group: 'Mgła',
    tags: ['cmentarz'],
    sectionId: 'mists-level-2',
  },
];
